import dynamic from 'next/dynamic'
import AlsoCheck from '~/src/components/AlsoCheck'
import HomeDiscoveryDrawer from '~/src/components/home/HomeDiscoveryDrawer'

const DupeInput = dynamic(() => import('~/src/components/DupeInput'), {
  ssr: false,
})

const HomepageInput: React.FC = () => {
  return (
    <DupeInput
      source='index-page'
      allowCamera
      expanded
      enableGradient
      openInNewTab
      className='pointer-events-auto relative min-h-[186px] w-full text-black dark:text-black'
    >
      {({ control }) => (
        <div className='mt-2 flex items-center justify-between px-3 md:mt-3 md:px-5'>
          <div className='flex items-center justify-between text-white'>
            <AlsoCheck control={control} />
          </div>
          <HomeDiscoveryDrawer />
        </div>
      )}
    </DupeInput>
  )
}

export default HomepageInput
